import { render, staticRenderFns } from "./MobileTwoNews.vue?vue&type=template&id=0298c6f6&scoped=true&"
import script from "./MobileTwoNews.vue?vue&type=script&lang=ts&"
export * from "./MobileTwoNews.vue?vue&type=script&lang=ts&"
import style0 from "./MobileTwoNews.vue?vue&type=style&index=0&id=0298c6f6&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0298c6f6",
  null
  
)

export default component.exports